// newsletter-ajax.js
// No-refresh handler for native Shopify newsletter forms (class .smr-news-form).
// Upload to Assets, then include once in the theme (see install note).
// The form still works without this file — it just falls back to a normal
// full-page redirect to Shopify's success page instead of an in-place message.
document.addEventListener('DOMContentLoaded', function () {
  var forms = document.querySelectorAll('.smr-news-form');
  if (!forms.length) return;

  Array.prototype.forEach.call(forms, function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();

      // Honeypot — if a bot filled the hidden field, drop the submission silently.
      var hp = form.querySelector('input[name="b_url"]');
      if (hp && hp.value) return;

      // Basic client-side email check before posting.
      var email = form.querySelector('input[type="email"]');
      if (!email || !email.value || email.value.indexOf('@') === -1) {
        if (email) email.focus();
        return;
      }

      var btn = form.querySelector('button[type="submit"]');
      if (btn) { btn.disabled = true; btn.textContent = 'Subscribing…'; }

      fetch('/contact', {
        method: 'POST',
        body: new FormData(form),
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
        .then(function () { showOk(form); })
        .catch(function () { showOk(form); });
    });
  });

  function showOk(form) {
    var wrap = form.parentNode;
    var msg = document.createElement('p');
    msg.className = 'smr-news-ok';
    msg.textContent = "You're in — thanks. Watch your inbox for the next guide.";
    form.style.display = 'none';
    wrap.appendChild(msg);
  }
});
